var map = {
	"./AdobeStock_291460215.jpeg": 5711,
	"./AdobeStock_306901276.jpeg": 5061,
	"./AdobeStock_82888729.jpeg": 1385,
	"./Certyfikat Mendel Helps.png": 5597,
	"./EkologiaMendelHelps.jpeg": 5333,
	"./MendelHelps.jpg": 5891,
	"./MendelHelpsShowLogo.jpg": 1529,
	"./Mendel_Helps_bialy1.png": 9453,
	"./Mendel_Helps_logo.png": 4314,
	"./Mendel_Helps_logo_male.png": 4880,
	"./Mendel_Helps_maly_sygnet.png": 9893,
	"./Mendel_Helps_sentence.png": 216,
	"./Mendel_Helps_sygnet_b.png": 3904,
	"./SPA.png": 2184,
	"./Spa_wypoczynek.jpeg": 2289,
	"./bad_floor.jpeg": 1946,
	"./broccoli.jpg": 6665,
	"./broccoli.png": 8049,
	"./brokuły.jpeg": 1763,
	"./buy_local.jpeg": 803,
	"./certyfikat.png": 2384,
	"./certyfikat_na_strone.png": 7356,
	"./co_kupujemy.jpeg": 4964,
	"./co_kupujemy.jpg": 7675,
	"./contact.jpeg": 199,
	"./contact1.jpeg": 9850,
	"./cross.png": 7270,
	"./czosnek.jpg": 9327,
	"./dowiedz_sie.png": 9260,
	"./dowiedz_sie1.png": 3775,
	"./ecoProd.png": 5122,
	"./envelope.png": 5944,
	"./facebook.png": 2180,
	"./facebook1.png": 3351,
	"./facebook2.png": 2668,
	"./facebook_logo.png": 5040,
	"./family1.png": 2111,
	"./find.png": 4409,
	"./food_laboratory.jpg": 4550,
	"./food_laboratory1.jpg": 7977,
	"./food_laboratory2.jpg": 6478,
	"./hand.png": 6711,
	"./healthyFood.jpg": 6777,
	"./healthyFood_background.jpg": 501,
	"./healthyFood_background1.jpeg": 1298,
	"./help.jpeg": 6918,
	"./home.png": 7789,
	"./hotele.jpeg": 9672,
	"./icon3.png": 60,
	"./ig_logo.png": 1240,
	"./insta.png": 5551,
	"./instagram.png": 6038,
	"./kup_zdrowe_produkty.jpeg": 6828,
	"./kup_zdrowe_produkty2.jpg": 5177,
	"./kup_zdrowe_produkty_odbicie.jpeg": 5510,
	"./laboratory.png": 4647,
	"./laboratory1.png": 7582,
	"./laboratory2.png": 4933,
	"./laboratory3.png": 5836,
	"./leaf.png": 1224,
	"./mail.png": 8954,
	"./mail1.png": 1456,
	"./nasze_porady.png": 4377,
	"./nasze_porady1.png": 7828,
	"./pexels-nick-collins-1392585.jpg": 2898,
	"./phone.png": 2698,
	"./phone1.png": 3705,
	"./phone2.png": 7122,
	"./piesek.jpg": 4017,
	"./plam.jpeg": 1851,
	"./plant.jpeg": 2974,
	"./plant1.jpeg": 9681,
	"./podpis1.png": 8130,
	"./poland.png": 648,
	"./poland_kup.png": 5481,
	"./poland_znajdz.png": 5294,
	"./poznaj_fakty.png": 2484,
	"./poznaj_fakty1.png": 7639,
	"./produkty.jpeg": 5043,
	"./rehabilitacja.jpg": 5681,
	"./rehabilitacja1.png": 2532,
	"./rehabilitacja2.png": 9391,
	"./rehabilitacja3.png": 2454,
	"./rest.jpeg": 3011,
	"./rest1.jpeg": 4046,
	"./rolnicy.jpeg": 1135,
	"./sanatoria.jpeg": 5547,
	"./sanatoria1.jpeg": 5142,
	"./sanatoria2.jpeg": 3427,
	"./shipping.png": 7918,
	"./shopInside.jpeg": 7073,
	"./shopProducts.jpg": 592,
	"./splesniale.png": 6468,
	"./store-icon.png": 8139,
	"./succes.jpeg": 487,
	"./triangle.png": 8296,
	"./vege.png": 3371,
	"./vegetable_garden.jpeg": 4204,
	"./website.png": 8409,
	"./wypoczynek.jpg": 369,
	"./wypoczynek1.jpeg": 5193,
	"./wypoczynek12.jpeg": 897,
	"./wypoczynek3.jpeg": 767,
	"./wypoczynek_ikona.png": 2744,
	"./wypoczynek_tlo.jpeg": 9080,
	"./zdrowe_odzywianie.jpeg": 3650,
	"./zdrowe_odzywianie1.jpeg": 2029,
	"./zdrowe_odzywianie12.jpeg": 5149,
	"./zle_mandarynki.jpeg": 3051,
	"./zostan_partnerem.jpeg": 1533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 282;